module.exports = __webpack_public_path__ + "img/p9-p1-molihua.6e86a51a.png";